import * as React from "react";
import { cn } from "@app/lib/utils";

export const ModalHeaderPrimitive = React.forwardRef<
  HTMLElement,
  React.HTMLAttributes<HTMLElement>
>(({ className, ...props }, ref) => (
  <header
    ref={ref}
    className={cn("border-b border-border px-5 py-4 pe-14", className)}
    {...props}
  />
));

ModalHeaderPrimitive.displayName = "ModalHeaderPrimitive";

export const ModalBodyPrimitive = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div ref={ref} className={cn("px-5 py-5", className)} {...props} />
));

ModalBodyPrimitive.displayName = "ModalBodyPrimitive";

export const ModalFooterPrimitive = React.forwardRef<
  HTMLElement,
  React.HTMLAttributes<HTMLElement>
>(({ className, ...props }, ref) => (
  <footer
    ref={ref}
    className={cn(
      "shrink-0 rounded-b-lg border-t border-border bg-card px-5 pb-[max(1rem,env(safe-area-inset-bottom))] pt-4 sm:px-6 sm:pb-4",
      className,
    )}
    {...props}
  />
));

ModalFooterPrimitive.displayName = "ModalFooterPrimitive";
